import React, { useEffect, useState, useMemo, useRef } from 'react';
import './index.scss';
import METRIC_LOCALES_EN from '@intelligence/_locales/en-US/metricSubValue';
import TOPCHARTS_LOCALES_EN from '@intelligence/_locales/en-US/topcharts';
import type { KPITrendsPropsType } from '@intelligence/types/topCharts';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { dbiPageLogMes, dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { useDispatch, useSelector } from 'umi';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import CommonFilter from '@intelligence/components/CommonFilter';
import {
  DEFAULTFILTERVALUE as defaultFilterValue,
  FILTERKEYLIST as filterKeyList,
  DEFAULTINPUTLIST as defaultInputList,
  DATABRAIN_UNITS_METRICS_SALES_SEGMENT_MAPPING,
  VISUAL_METRIC_DEFAULT_MAPPING,
  DATABRAIN_METRIC_MAPPING,
  DATABRAIN_CALIBRATION_METRICS,
} from './const';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import useKPITrends from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/hooks/useKPITrends';
import useVisualMetrics from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/hooks/useVisualMetrics';
import { useCalibrationMode } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/hooks';
import useKpiTrendsHourSegment from './hooks/useKpiTrendsHourSegment';
import {
  expandMetricOptionsWithMultiValue,
  isMultiValuePriceMetric,
} from '@intelligence/pages/TopCharts/utils/multiValueMetricUtils';
import { formatTrueDataSeriesName } from '@intelligence/pages/TopCharts/utils/seriesDisplay';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
// import { updateFilterSaveList } from '@/pages/intelligence/services/common';
import {
  // getUserSaveParams,
  // USERSAVEKEY_KPITRENDS as userSaveFilterValueKey,
  handleDetailKPITrendsFilterParamsToApi as handleFilterToApiParams,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import useInitFilterHook from '@intelligence/hooks/useInitFilterHook';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { TopchartPageId, PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { KPITrendsPageConfig } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import { useOpinionChartEventsWithDateLimit } from '@intelligence/v3/components/OpinionBarAndLineChart/hooks/useOpinionChartEventsWithDateLimit';
import OpinionEventSettingToolbar from '@intelligence/v3/components/OpinionBarAndLineChart/OpinionEventSettingToolbar';
import { buildEventClusterGameIds } from '@intelligence/v3/components/OpinionBarAndLineChart/hooks/utils/buildEventClusterGameIds';
import { buildOpinionEventSettingStorageKey } from '@intelligence/v3/components/OpinionBarAndLineChart/hooks/utils/opinionChartEventSettingStorage';
import VisualMetricSelectorDual from './components/VisualMetricSelectorDual';
import TrendsVisualTableContent from './TrendsVisualTableContent';
import MscienceIcon from '@intelligence/assets/svg/dataSource/mscience-bg.svg';
import {
  allMetricsOptions,
  allMetricsSourcesOption,
  getMetricOptionByValue,
  getSourceMetricsByValue,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import { buildOrderMetricsFromPageMetricValues } from '@intelligence/components/DownloadCommon/DownloadPage/utils/reorderCombineDetailDownloadMetrics';
import {
  getAlineaTrueDataSelections,
  isAlineaTrueDataGlobalAggregate,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/utils/alineaTrueData';
import useShowSumAvgInfo from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/hooks/useShowSumAvgInfo';
import useAlineaTrueData from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/hooks/useAlineaTrueData';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import {
  getURLSearchParams,
  updateURLSearchParams,
} from '@intelligence/utils/commonUtils';
import {
  checkIsEmptyList,
  getSinceReleaseTimeOfRangePicker,
} from '@intelligence/utils/topchartsUtils';
import { reportButtonLog } from '@intelligence/v3/utils/logReporter';
import {
  CALIBRATION_METRICS,
  checkIsSegmentForSalesOnlyCheckedBaseGame,
  getAllValuesOfCascader,
  notificationAutoAdjustSegmentForSalesTips,
  calcIsDataBrainCalibrationMetricsOnly,
  calcIsSegmentForSalesAllChecked,
} from './utils';
import DataSourceExplanation from '@intelligence/v3/components/DataSourceExplanation';
import {
  DATASOURCE_EXPLANATION_HTML_DATASOURCE_LIST,
  getDataSourceExplanationHtmlContent,
} from './utils/dataSourceExplanationHtmlConfig';
import {
  logKpiTrendsFilterChange,
  logVisualMetricSelectorDualChange,
  logCalibrationClick,
} from './utils/loggingUtils';
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import { containsAmpereMetric } from '@intelligence/utils/filterUtils';
import useRadioOptionsTipsGetterOfRegionSelect from '@intelligence/hooks/useRadioOptionsTipsGetterOfRegionSelect';
import useConfigureTexts from '@intelligence/hooks/useConfigureTexts';
import {
  FILTER_URL_CONFIG,
  TOPCHARTS_METRICS_INHERIT_QUERY_KEY,
  type IFilterUrlConfigItem,
  type TUrlQueryKey,
} from '@intelligence/_config/components/filterUrl/kpiTrends';
import {
  isKpiTrendsHourlyGranularity,
  isKpiTrendsHourlyDateType,
  buildFilterValuePatchWhenLeavingHour,
  shouldRestoreDefaultMetricsWhenLeavingHour,
  filterVisMetricsOptionsForGranularity,
  findFirstNonHourlyCcuMetric,
} from './hourSegmentUtils';
import queryString from 'query-string';
import { handleMetricExplanationTipsClick } from '@intelligence/v3/utils/topcharts';
import useSearchParams from '@intelligence/hooks/useSearchParams';
import { LANGUAGE_CN } from '@home/_config/config';

// 当前游戏不持支对应数据源指标时，需要禁用的数据源键列表
const disabledDataSourcesWhenNotSupport: string[] = ['databrain'];

// 默认排序
const pageSortAttr = {
  currentSortValue: 'desc',
  currentSortMetric: 'date',
  currentRatioType: 0,
};

/** Hour 模式 URL 仅同步 granularity + start/end；其余粒度走完整 FILTER_URL_CONFIG */
const buildKpiTrendsFilterUrlConfig = (
  rangeTimeType?: string,
  formatDate = 'true',
): Record<TUrlQueryKey, IFilterUrlConfigItem> => {
  if (rangeTimeType === 'hour') {
    const { granularity, start_date, end_date } = FILTER_URL_CONFIG;
    return { granularity, start_date, end_date } as Record<
      TUrlQueryKey,
      IFilterUrlConfigItem
    >;
  }

  if (formatDate === 'true') return FILTER_URL_CONFIG;

  return {
    ...FILTER_URL_CONFIG,
    start_date: {
      ...FILTER_URL_CONFIG.start_date,
      input: 'string',
    },
    end_date: {
      ...FILTER_URL_CONFIG.end_date,
      input: 'string',
    },
  };
};

/**
 * 获取当前游戏需要禁用的数据源键列表
 * @param basicInfo 当前游戏详情
 * @return 当前游戏需要禁用的数据源键列表
 */
const getDisabledDataSources = (basicInfo?: any): string[] => {
  const supportMetrics = basicInfo?.support_metrics || {};
  return disabledDataSourcesWhenNotSupport.filter((dataSource) => {
    return !Reflect.has(supportMetrics, dataSource);
  });
};

const isDatabrainCalibrationMetricSelection = (metrics: string[] = []) => {
  if (!Array.isArray(metrics)) return false;
  if (metrics.length !== DATABRAIN_CALIBRATION_METRICS.length) return false;
  const metricsSet = new Set(metrics);
  return DATABRAIN_CALIBRATION_METRICS.every((metric) => metricsSet.has(metric));
};

// 融合游戏详情KPITrends内容
const KPITrends = (props: KPITrendsPropsType) => {
  const {
    gameId,
    entityType = 'combine',
    releaseTime,
    activeSegment,
    basicInfo,
    appIds,
    tabType,
    isBasicLoading,
    feedBackParams,
    opinionId,
    combineGameIdList,
  } = props;
  const dispatch = useDispatch();
  const { locale, formatMessage } = useIntlExtend();
  const getRadioOptionsTips = useRadioOptionsTipsGetterOfRegionSelect();
  const { configureTexts } = useConfigureTexts();
  const {
    // 是否为DataBrain校准数据和真数模式
    isDataBrainTrueDataMode: isDataBrainTrueDataModeFromUrl,
    // 是否从DataBrain Calibration TopCharts页面跳转过来
    isFromDataBrainCalibrationTopCharts,
    [TOPCHARTS_METRICS_INHERIT_QUERY_KEY]: inheritTopChartsMetrics,
  } = useSearchParams();
  const shouldInheritTopChartsMetrics = inheritTopChartsMetrics === '1';
  const shouldAutoSwitchCalibration = Boolean(isFromDataBrainCalibrationTopCharts) && !shouldInheritTopChartsMetrics;

  const MSCIENCE_ICON = (
    <img style={{ verticalAlign: 'text-top' }} src={MscienceIcon} />
  );
  // 是否为首次加载页面数据
  const isFirst = useRef(true);

  // 指标跳转指定勾选的指标（暂存）
  const jumpVisualMetrics = useRef<string[] | null>(null);

  // 数据源解释说明功能容器Ref
  const dataSourceExplanationTriggerRef = useRef<HTMLElement>(null);
  const dataSourceExplanationBodyRef = useRef<HTMLElement>(null);

  updateURLSearchParams({}, ['isDataBrainTrueDataMode', 'isFromDataBrainCalibrationTopCharts', TOPCHARTS_METRICS_INHERIT_QUERY_KEY]);

  /** 筛选器value数据 **/
  const [filterValue, setFilterValue] = useState<any>(defaultFilterValue);

  const containsAmpere = useMemo(() => {
    return containsAmpereMetric(
      filterValue?.[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value?.metrics,
    );
  }, [filterValue]);

  const disableNoChinaDynamic = useMemo(() => {
    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
      return !containsAmpere;
    }
    return true;
  }, [entityType, containsAmpere]);

  // 次要兜底：在 disableNoChina=true 的前提下，若当前 region 仍为 'global_wo_china'，
  // 显式将 markets 重置为 ['global']，让 RegionSelector UI 与禁用态保持一致。
  // 主要的请求层兜底在 fetchFilterChange 入口（覆盖首屏继承 + 用户取消 Ampere 提交）；
  // 这里仅处理 setFilterValue 直接被外部调用的边缘场景，
  const regionMarketsKey = filterValue?.[filterKeyMap.REGION]?.markets?.[0];
  useEffect(() => {
    if (disableNoChinaDynamic !== true) return;
    if (regionMarketsKey !== 'global_wo_china') return;
    setFilterValue((prev: any) => ({
      ...prev,
      [filterKeyMap.REGION]: {
        ...(prev?.[filterKeyMap.REGION] || {}),
        regions: ['global'],
        markets: ['global'],
        type: 'market',
      },
    }));
  }, [disableNoChinaDynamic, regionMarketsKey]);
  // const [defaultVisualMetricsValue, setDefaultVisualMetricsValue] = useState<string>('');

  // Databrain availability flags derived from basicInfo.support_metrics
  const hasDatabrainCalibratedData = useMemo(() => {
    const metrics = (basicInfo as any)?.support_metrics;
    if (metrics && !Array.isArray(metrics) && typeof metrics === 'object') {
      const hasDatabrain = Boolean(
        (metrics as any)?.databrain || (metrics as any)?.data_brain,
      );
      return hasDatabrain;
    }
    return false;
  }, [basicInfo]);
  /** true 表示 Basic Info 已确认该游戏存在 Alinea Calibration 真数；false 时不展示真数入口。 */
  const hasAlineaCalibratedData = Boolean(
    (basicInfo as any)?.support_metrics?.alinea_calibration,
  );
  // const [defaultVisualMetricsValue, setDefaultVisualMetricsValue] = useState<string>('');
  const topchartsState = useSelector(
    (state: any) => state?.[DBI_TOPCHARTS] || {},
  );
  const { metricValueListObj, metricValueRangeTime } = topchartsState;
  const { metricListValue } = metricValueListObj;
  const [trendChartType, setTrendChartType] = useState<string>(ChartType.Line);
  // By Platform 按钮
  const [byDevice, setByDevice] = useState(false);
  // By Country 按钮
  const [byCountry, setByCountry] = useState(false);

  // 用户是否手动修改了国家区域
  const userManuallyChangedRegionRef = useRef(
    Boolean(getURLSearchParams('custom_region')),
  );

  const userSegmentChangedRegionRef = useRef(
    Boolean(getURLSearchParams('cascader')),
  );

  const formatDate =
    queryString.parse(window.location.search).format_date || 'true';

  const userSegmentCloseRef = useRef(false);

  const selectorInputList = useMemo(() => {
    // combine 只标记 PC&Console 的指标选择器；其它实体继续使用原 Mobile 分类契约。
    if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE) return defaultInputList;
    return defaultInputList.map((item: any) =>
      item?.key === filterKeyMap.METRIC_SELECT_FOR_KPI_TREND
        ? { ...item, entityType }
        : item,
    );
  }, [defaultInputList, entityType]);

  const {
    activeFilterKeyList,
    activeDefaultInputList,
    filterValueForRender,
    pageClassName,
    applyHourRangeClampToPayload,
    downloadParamsPatch,
    selectMetricsOptionsCur,
    isHourlyMode,
    download,
    ui: hourSegmentUi,
  } = useKpiTrendsHourSegment({
    filterValue,
    setFilterValue,
    defaultFilterValue,
    defaultInputList: selectorInputList,
    filterKeyList,
    setByDevice,
    setByCountry,
  });

  // Basic filter configuration (without calibration switcher - will be added later)
  const baseFilterCfg = useMemo(() => ({
    filterKeyList: activeFilterKeyList,
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    showConfirmButton: false,
    isCustomLayoutFilter: true,
    specialParams: {
      defalutMarket: ['global'], // 没取到交集用的默认值
      // disableNoChina 动态注入：PC&Console 场景下含 Ampere 指标时启用 'Global except China mainland'
      disableNoChina: disableNoChinaDynamic,
      digitalSegementTips: formatMessage(
        { id: 'dbi_info_segement_mscience' },
        { mscienceIcon: MSCIENCE_ICON },
      ),
      entityType,
      showSelectType: false,
      rangeTimeOtherStyle: true,
      cascaderFooterMsg: configureTexts?.segment_for_sales_select_tips,
      hasDatabrainData: hasDatabrainCalibratedData,
      disabledDataSources: getDisabledDataSources(basicInfo),
      // DataSourceExplanation 容器Ref
      dataSourceExplanationTriggerRef,
      dataSourceExplanationBodyRef,
    },
  }), [hasDatabrainCalibratedData, basicInfo, formatMessage, configureTexts, entityType, disableNoChinaDynamic, dataSourceExplanationTriggerRef, dataSourceExplanationBodyRef, activeFilterKeyList]);

  const handlePageLog = (gameId: string) => {
    const pageLogMes = dbiPageLogMes.pcConsoleGameDetailsKPITrends;
    if (gameId) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    recordPageMesForFeedback(pageLogMes);
  };

  useEffect(() => {
    handlePageLog(gameId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameId]);



  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const getEarliestDate = (params: any) => {
    updateEarliestDateData({
      ...params,
      dataSources: [],
      metrics: params.source_metrics,
      regionType: params.region_type,
      regions: params.regions,
      dateType: params.date_type,
      segment: params.segment || '',
      platform: params.device || '',
      earliesUrl: '/api/v1/intelligence_pc/gameDetail/allMetrics/earliestDate',
    });
  };

  const { regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.metricTable,
  });

  const {
    fetchParams,
    devicePieDatas,
    deviceTrendsDatas,
    countryTrendsData,
    trendsTableDataList,
    fetchLoading,
    fetchPlatFormDataLoading,
    setFetchLoading,
    getIndexPageData,
    pieData,
    visualMetricValue: kpiVisualMetricValue,
    setVisualMetricValue: setKpiVisualMetricValue,
    selectVisMetricsOptions,
    sumAvgMaxList,
    getKPITrendsPiePlatformData,
    isCancelledRef,
    calibrationFlags: calibrationFlagsFromHook,
  } = useKPITrends({
    entityType,
    gameId,
    filterCfg: baseFilterCfg,
    filterValue,
    setFilterValue,
    getEarliestDate,
    metricListValue,
    metricValueRangeTime,
    defaultFilterValue: filterValue,
    // defaultVisualMetricsValue,
    activeSegment,
    jumpVisualMetrics,
    regionOptions,
  });



  // Use the custom hook for visual metrics management
  const {
    visualMetricValue,
    visualMetricValues,
    setVisualMetricValue,
    setVisualMetricValues,
    handleDualMetricChange,
    handleMetricSelectChange: handleVisualMetricChange,
  } = useVisualMetrics({
    activeSegment,
    selectedMetrics:
      filterValue?.[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value?.metrics,
    onMetricChange: (value: string) => {
      setKpiVisualMetricValue(value);

      const hasPlatFormData = allMetricsOptions.find(
        (item) => item.value === value,
      )?.hasByDevice;

      // 当前切换到的指标，有 by platform 数据的才请求 trend_chart 接口
      const isPie = trendChartType === ChartType.Pie;
      if (hasPlatFormData && (byDevice || isPie)) {
        getKPITrendsPiePlatformData({
          params: fetchParams,
          currentMetricValue: value,
          isPie,
          isByPlatform: byDevice,
          isByCountry: byCountry,
        });
      }
    },
  });

  /** 非 Hour 粒度下立即排除 hourly CCU，避免离开 Hour tab 后 selector 短暂闪现 */
  const selectVisMetricsOptionsEffective = useMemo(
    () =>
      filterVisMetricsOptionsForGranularity(
        selectVisMetricsOptions || [],
        // 非 Hour 时任意非 hourly granularity 均可，此处仅用于触发 CCU 排除
        isHourlyMode ? 'hourly' : 'daily',
      ),
    [selectVisMetricsOptions, isHourlyMode],
  );

  const visualMetricValuesForSelector = useMemo(() => {
    if (!selectVisMetricsOptionsEffective.length) {
      return visualMetricValues || [];
    }
    const optionValueSet = new Set(
      selectVisMetricsOptionsEffective.map(
        (option: { value: string }) => option.value,
      ),
    );
    const validValues = (visualMetricValues || []).filter((value) =>
      optionValueSet.has(value),
    );
    if (validValues.length) return validValues;

    const fallbackMetric =
      findFirstNonHourlyCcuMetric(selectVisMetricsOptionsEffective) ||
      selectVisMetricsOptionsEffective[0]?.value;
    return fallbackMetric ? [fallbackMetric] : [];
  }, [visualMetricValues, selectVisMetricsOptionsEffective]);

  const visualAlineaMetricOptions = useMemo(() => {
    const visualMetricValueSet = new Set(visualMetricValuesForSelector);
    return (selectVisMetricsOptionsEffective || []).filter((item: any) =>
      visualMetricValueSet.has(item?.value),
    );
  }, [selectVisMetricsOptionsEffective, visualMetricValuesForSelector]);

  /**
   * true 表示当前趋势图是 Global 聚合且未进入国家/Region/Platform/Segment 拆分，允许展示 History 真数；
   * false 时不请求也不展示 History，避免拆分视图叠加 Global 真数。
   */
  const isGlobalAggregate = isAlineaTrueDataGlobalAggregate({
    params: fetchParams,
    byDevice,
    byCountry,
  });

  const { alineaTrueDataSeries, isAlineaTrueDataLoading } = useAlineaTrueData({
    gameId,
    entityType,
    dateType: fetchParams?.date_type,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
    selectedMetricOptions: selectMetricsOptionsCur,
    visualMetricOptions: visualAlineaMetricOptions,
    isGlobalAggregate,
  });

  // Wrap handleDualMetricChange to add logging
  const handleDualMetricChangeWrapper = (values: string[]) => {
    const previousValues = visualMetricValues;
    handleDualMetricChange(values);

    // Log the change
    logVisualMetricSelectorDualChange(
      previousValues,
      values,
      gameId,
      basicInfo?.name || '',
    );
  };

  const {
    earliestPeriod,
    formattedEarliestDay,
    updateEarliestDateData,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType,
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
    platforms: fetchParams.device || [],
    // isReleaseTimeByPlatforms: true,
  });

  const loading = fetchLoading || fetchPlatFormDataLoading;

  const cardStatus = {
    isLoading: loading,
    // History 是趋势图的独立数据源；普通趋势为空时，只要当前指标有 History 点，仍应允许图表渲染。
    isNoData:
      trendsTableDataList?.length < 1 &&
      !alineaTrueDataSeries.length &&
      !isAlineaTrueDataLoading,
  };

  // 用户需要保存的操作记录
  // const updateUserSaveParams = async (typeValu: string, params: any) => {
  //   await updateFilterSaveList({
  //     name: typeValu,
  //     type: typeValu,
  //     data: JSON.stringify(params || {}),
  //   });
  // };

  /**
   * 筛选器统一值处理后，confirm回调
   */
  const fetchFilterChange = async (payload: any) => {
    // 若有需要保存用户操作记录，则调用
    // updateUserSaveParams(
    //   userSaveFilterValueKey,
    //   getUserSaveParams(payload, userSaveFilterValueKey),
    // );

    // 兜底：在 PC&Console（combine）场景下，若当前指标集合不含 Ampere（即
    // RegionSelector 中 'Global except China mainland' 处于 disabled 状态），
    // 但 payload 中的 region 仍为 'global_wo_china'，则强制回退为 'global'。
    // 触发场景：
    //   1. 从榜单页携带 region=global_wo_china 下钻进入详情页时，KPI Trends 的
    //      默认指标可能不含 Ampere，useInitFilterHook 会同步把继承到的 region 透
    //      传到此处发起首屏请求；
    //   2. 用户在详情页内取消勾选最后一个 Ampere 指标后再次提交，CommonFilter 也会
    //      同步走到这里。
    // 在 useInitFilterHook 的 filterConfirm 回调里同步矫正 payload + 回写
    // setFilterValue，可以保证：
    //   a. 接口请求使用矫正后的 markets，避免空数据；
    //   b. UI 中 RegionSelector 立即同步到 'global'（同一批 React 更新中，
    //      此处的 setFilterValue 在 useInitFilterHook 内部那次 setFilterValue
    //      之后调用，覆盖前者）；
    // 该兜底放在页面侧而不是通用 useInitFilterHook 中，避免侵入共用 hook。
    let effectivePayload = payload;
    effectivePayload = applyHourRangeClampToPayload(effectivePayload);

    const payloadRangeType = effectivePayload?.[filterKeyMap.RANGE_TIME]?.type;
    const payloadMetrics =
      effectivePayload?.[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value
        ?.metrics;
    if (
      payloadRangeType &&
      !isKpiTrendsHourlyDateType(payloadRangeType) &&
      shouldRestoreDefaultMetricsWhenLeavingHour(payloadMetrics)
    ) {
      effectivePayload = buildFilterValuePatchWhenLeavingHour(
        effectivePayload,
        defaultFilterValue,
      );
      setFilterValue((prev: Record<string, any>) =>
        buildFilterValuePatchWhenLeavingHour(prev, defaultFilterValue),
      );
      const restoredMetric =
        effectivePayload?.[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value
          ?.metrics?.[0];
      if (restoredMetric) {
        setKpiVisualMetricValue(restoredMetric);
        setVisualMetricValue(restoredMetric);
        setVisualMetricValues([restoredMetric]);
      }
    }

    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
      const incomingMarkets =
        effectivePayload?.[filterKeyMap.REGION]?.markets;
      const incomingMetrics =
        effectivePayload?.[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value
          ?.metrics;
      if (
        incomingMarkets?.[0] === 'global_wo_china' &&
        !containsAmpereMetric(incomingMetrics)
      ) {
        effectivePayload = {
          ...effectivePayload,
          [filterKeyMap.REGION]: {
            ...(effectivePayload?.[filterKeyMap.REGION] || {}),
            regions: ['global'],
            markets: ['global'],
            type: 'market',
          },
        };
        setFilterValue((prev: any) => ({
          ...prev,
          [filterKeyMap.REGION]: effectivePayload[filterKeyMap.REGION],
        }));
      }
    }

    const rawCascader =
      effectivePayload?.[filterKeyMap.CASCADER] ??
      effectivePayload?.cascader ??
      defaultFilterValue[filterKeyMap.CASCADER];

    const params = handleFilterToApiParams(fetchParams, {
      ...effectivePayload,
      cascader: dealSegmentAllData(rawCascader),
      cascadersByDownload: rawCascader,
    });
    const { trendRes: trendsRes, nextFilterValue: syncedFilterValue } =
      (await getIndexPageData(params, effectivePayload)) || {};

    if (updateUrl && syncedFilterValue) {
      const syncedRangeType =
        syncedFilterValue?.[filterKeyMap.RANGE_TIME]?.type;
      const urlConfig = buildKpiTrendsFilterUrlConfig(
        syncedRangeType,
        formatDate,
      );
      await updateUrl(
        {
          ...syncedFilterValue,
          visualMetricValue,
          byDevice,
        },
        urlConfig,
        true,
        '?',
      );
    }

    if (isFirst.current) {
      isFirst.current = false;
      const isNoData = checkIsEmptyList(
        trendsRes?.data?.[0]?.metric_value_list,
      );
      const isSegmentForSalesOnlyCheckedBaseGame =
        checkIsSegmentForSalesOnlyCheckedBaseGame(
          effectivePayload?.[filterKeyMap.CASCADER]?.value,
        );
      // isCancelledRef表示接口是否进入catch。正常重新调用接口是需要在接口返回数据为空，而不是取消
      if (
        isNoData &&
        isSegmentForSalesOnlyCheckedBaseGame &&
        !isCancelledRef.current
      ) {
        // @ts-ignore
        const cascaderOptions = defaultInputList?.find(
          (item) => item?.key === filterKeyMap.CASCADER,
        )?.options?.children;
        const payloadTmp = {
          ...effectivePayload,
          [filterKeyMap.CASCADER]: {
            value: getAllValuesOfCascader(cascaderOptions),
          },
        };
        await fetchFilterChange(payloadTmp);
        notificationAutoAdjustSegmentForSalesTips({
          locale,
          onCancel: () => {
            const defaultCascaderFilterValue = Object.keys(
              effectivePayload?.[filterKeyMap.CASCADER]?.value || {},
            ).reduce((acc, cur) => {
              return { ...acc, [cur]: ['Full Game'] };
            }, {});
            const payloadTmp = {
              ...effectivePayload,
              [filterKeyMap.CASCADER]: {
                value: defaultCascaderFilterValue,
              },
            };
            fetchFilterChange(payloadTmp);
          },
        });
        return;
      }
    }

    const isPie = trendChartType === ChartType.Pie;
    if (byDevice || isPie) {
      getKPITrendsPiePlatformData({
        params,
        isPie,
        isByPlatform: byDevice,
        isByCountry: byCountry,
      });
    }
  };

  const dealSegmentAllData = (data: any) => {
    const cascaderData =
      data?.value != null
        ? data
        : defaultFilterValue[filterKeyMap.CASCADER];
    const { value } = JSON.parse(JSON.stringify(cascaderData));
    const targetData: any = defaultInputList.find(
      (item: any) => item.key === filterKeyMap.CASCADER,
    );
    if (!value || !targetData?.options?.children) {
      return cascaderData;
    }
    Object.keys(value).forEach((key) => {
      targetData.options.children.map((targetItem: any) => {
        if (
          targetItem.value === key &&
          value[key].length === targetItem.children.length
        ) {
          value[key] = ['All'];
        }
      });
    });
    return {
      value,
    };
  };

  const getNewFilterValue = (newObj: any, oldObj: any) => {
    const newObjTmp: any = {};
    Object.keys(oldObj).forEach((key) => {
      switch (key) {
        case 'metric_selection_for_trends': {
          const newValue = newObj[key]?.value;
          const metricTmp: string[] = [];
          Object.values(newValue?.source_metrics || {}).forEach(
            (item: string[]) => {
              metricTmp.push(...item);
            },
          );
          newObjTmp[key] = {
            value: Object.assign({}, oldObj[key]?.value, {
              ...newObj[key]?.value,
              metrics: metricTmp,
            }),
          };
          break;
        }
        case 'byDevice':
        case 'visualMetricValue':
          newObjTmp[key] = oldObj[key];
          break;
        default:
          newObjTmp[key] = {
            ...oldObj[key],
            ...newObj[key],
          };
          break;
      }
    });
    return newObjTmp;
  };

  const filterConfig = useMemo(
    () => buildKpiTrendsFilterUrlConfig(filterValue?.rangeTime?.type, formatDate),
    [formatDate, filterValue?.rangeTime?.type],
  );

  // filter公共hooks，暴露全局统一处理filterValue方法，再调接口
  const { updateFilterDatas, decodeUrlToFilterValue, updateUrl } =
    useInitFilterHook({
      entityType,
      filterCfg: baseFilterCfg,
      filterValue: {
        ...filterValue,
        // visualMetricValue,
        byDevice,
      },
      setFilterValue,
      filterConfirm: fetchFilterChange,
      isBasicLoading,
      activeSegment,
      defaultInputList,
      shouldSetUSOrGlobalRegionByMetrics: true,
      pageId: 'segmentDefauleValue',
      pageIds: 'segmentDefauleValues',
      needUpdateUrl: true,
      needDecodeUrl: true,
      isShortIdMode: true,
      isShortMode: true,
      isDataBrainTrueDataMode: isDataBrainTrueDataModeFromUrl,
      executable: !shouldAutoSwitchCalibration,
      filterConfig,
      filterValueFormatter: getNewFilterValue,
    });

  // console.log({encodeStr, encodeOirginalStr, shortId, decodeObj});

  const restoreDefault = useRef(false);

  // 设置特殊结点， 只判断处理Cascader关闭处理 platform_cascader 关闭后直接调用
  const specialCascader = useRef(false);

  // Use calibration mode hook
  const {
    calibrationFlags,
    isDataBrainTrueDataMode,
    isCalibrationSwitcherDisabled: isCalibrationMetricsSwitcherDisabled,
    handleViewCalibrationData,
    switchToCalibrationMode,
    handleSetRegionUSOnly,
    updateSwitcherDisabled,
  } = useCalibrationMode({
    calibrationFlagsFromHook,
    filterValue,
    defaultInputList,
    releaseTime,
    gameId,
    gameName: basicInfo?.name || '',
    byDevice,
    isFromDataBrainCalibrationTopCharts: shouldAutoSwitchCalibration,
    setFilterValue,
    updateUrl,
    updateFilterDatas,
    setKpiVisualMetricValue,
    setVisualMetricValue,
    setVisualMetricValues,
    jumpVisualMetricsRef: jumpVisualMetrics,
    userManuallyChangedRegionRef,
    userSegmentChangedRegionRef,
    userSegmentCloseRef,
    restoreDefault,
    specialCascader,
  });

  // Complete filter configuration (extends base with calibration switcher)
  const eventClusterGameIds = useMemo(
    () => buildEventClusterGameIds(combineGameIdList, gameId),
    [combineGameIdList, gameId],
  );

  const settingStorageKey = useMemo(
    () => (gameId ? buildOpinionEventSettingStorageKey('kpi-trends', gameId) : undefined),
    [gameId],
  );

  const showOpinionEventToolbar = useMemo(() => {
    if (isHourlyMode) return false;
    if (trendChartType === ChartType.Pie) return false;
    return eventClusterGameIds.length > 0;
  }, [isHourlyMode, trendChartType, eventClusterGameIds]);

  const showOpinionEventSetting = useMemo(() => {
    return (
      showOpinionEventToolbar &&
      !!fetchParams?.start_date &&
      !!fetchParams?.end_date
    );
  }, [
    showOpinionEventToolbar,
    fetchParams?.start_date,
    fetchParams?.end_date,
  ]);

  const {
    eventData: opinionEventData,
    chartEventSetting: opinionChartEventSetting,
    changeEventSetting: changeOpinionEventSetting,
    loading: opinionEventLoading,
  } = useOpinionChartEventsWithDateLimit({
    gameIds: eventClusterGameIds,
    settingStorageKey,
    startTime: fetchParams?.start_date || '',
    endTime: fetchParams?.end_date || '',
    dateType: fetchParams?.date_type,
    entityType,
    enabled: showOpinionEventSetting,
  });

  const opinionChartXAxisData = useMemo(
    () =>
      (trendsTableDataList || [])
        .map((item: any) => item?.date || item?.metric_date)
        .filter(Boolean)
        .map((date: string) => String(date)),
    [trendsTableDataList],
  );

  const filterCfg = useMemo(() => ({
    ...baseFilterCfg,
    specialParams: {
      ...baseFilterCfg.specialParams,
      opinionEventSetting: showOpinionEventToolbar ? (
        <OpinionEventSettingToolbar
          eventData={opinionEventData}
          chartEventSetting={opinionChartEventSetting}
          onEventSettingChange={changeOpinionEventSetting}
          xAxisData={opinionChartXAxisData}
          dateType={fetchParams?.date_type}
          startTime={fetchParams?.start_date}
          endTime={fetchParams?.end_date}
        />
      ) : null,
      calibrationMetricsSwitcher: {
        visible: hasDatabrainCalibratedData && hourSegmentUi.showCalibrationSwitcher,
        disabled: isCalibrationMetricsSwitcherDisabled,
        bubblePlacement: locale === LANGUAGE_CN ? 'top-end' : 'top',
        bubbleContent: isCalibrationMetricsSwitcherDisabled
          ? formatMessage({ id: 'dbi_top_calibration_metrics_switcher_disabled_tips' })
          : formatMessage({ id: 'dbi_top_calibration_metrics_switcher_tips' }),
        style: {
          width: '100%',
          maxWidth: 280,
          minWidth: 200,
          marginLeft: 0,
          justifyContent: 'flex-end',
          flexShrink: 0,
        },
        onSwitch: switchToCalibrationMode,
      },
    },
  }), [
    baseFilterCfg,
    hourSegmentUi.showCalibrationSwitcher,
    isCalibrationMetricsSwitcherDisabled,
    switchToCalibrationMode,
    hasDatabrainCalibratedData,
    locale,
    formatMessage,
    showOpinionEventToolbar,
    opinionEventData,
    opinionChartEventSetting,
    changeOpinionEventSetting,
    opinionChartXAxisData,
    fetchParams?.date_type,
    fetchParams?.start_date,
    fetchParams?.end_date,
  ]);

  const handleChangeExtra = (key: string, value: any, newValue: any) => {
    if (key === 'region') {
      userManuallyChangedRegionRef.current = true;
      updateURLSearchParams({ custom_region: true });
    }
    userSegmentCloseRef.current = true;
    specialCascader.current = false;
    if (key === 'cascader') {
      const mapNullArr = Object.values(value.value);
      restoreDefault.current = true;
      mapNullArr.forEach((item: any) => {
        if (item.length) {
          restoreDefault.current = false;
        }
      });
      userSegmentChangedRegionRef.current = true;
      userSegmentCloseRef.current = newValue.isClose || false;
    }

    if (key === 'platform_cascader') {
      userSegmentCloseRef.current = newValue.isClose || false;
      specialCascader.current = true;
    }
  };

  // 可视化图表内显示当前选中指标文案
  const visualisTitleNow = useMemo(() => {
    if (byDevice || trendChartType === ChartType.Pie) {
      // 找出当前选中项对应指标文案
      const currentMetric = selectVisMetricsOptionsEffective?.find(
        (metric: { value: string }) => metric.value === visualMetricValue,
      );
      return formatMessage({ id: currentMetric?.text || currentMetric?.value });
    }
    return formatMessage({ id: 'dbi_data' });
  }, [locale, byDevice, trendChartType, visualMetricValue, selectVisMetricsOptions]);

  const tableMetricListExpanded = useMemo(
    () =>
      expandMetricOptionsWithMultiValue(
        selectMetricsOptionsCur,
        trendsTableDataList,
        formatMessage,
      ),
    [selectMetricsOptionsCur, trendsTableDataList, formatMessage, locale],
  );

  // 手动选择下拉框选项触发 Metric 变化
  const isManuallyTriggerMetricSelectRef = useRef(false);

  const handleMetricSelectChange = (value: string, needUpdateUrl = true) => {
    handleVisualMetricChange(value, needUpdateUrl);
    isManuallyTriggerMetricSelectRef.current = true;

    if (!needUpdateUrl) return;
    // if (updateUrl) {
    //   updateUrl({
    //     ...filterValue,
    //     visualMetricValue: value,
    //     byDevice,
    //   }, FILTER_URL_CONFIG, true);
    // }
  };

  // 折线图饼图切换，饼图数据从新接口获取
  const handleChartTypeChange = (chartType: string) => {
    // console.log('handleChartTypeChange-chartType', chartType);
    getKPITrendsPiePlatformData({
      params: fetchParams,
      isByPlatform: byDevice,
      isPie: chartType === ChartType.Pie,
      isByCountry: byCountry,
    });
  };

  // By Platform切换，数据从新接口获取
  const handleByPlatformChange = (
    isByPlatform: boolean,
    needUpdateUrl = true,
  ) => {
    setByDevice(isByPlatform);
    getKPITrendsPiePlatformData({
      params: fetchParams,
      isByPlatform,
      isPie: trendChartType === ChartType.Pie,
    });
    if (!needUpdateUrl) return;
    if (updateUrl) {
      updateUrl(
        {
          ...filterValue,
          // visualMetricValue,
          byDevice: isByPlatform,
        },
        buildKpiTrendsFilterUrlConfig(filterValue?.rangeTime?.type, formatDate),
        true,
      );
    }
  };

  // By Country切换
  const handleByCountryChange = (isByCountry: boolean) => {
    setByCountry(isByCountry);

    // 选中按国家时，markets 需要携带 region 筛选器的全部国家 country_code
    const allCountryCodes = (regionOptions || []).reduce(
      (acc: string[], region: any) => {
        const codes = (region?.country_set || []).map(
          (c: any) => c.country_code,
        );
        return acc.concat(codes);
      },
      [],
    );

    // 构造更新后的 filterValue，勾选时将 region 设为全部国家，取消时恢复为 global
    const newFilterValue = isByCountry
      ? {
          ...filterValue,
          region: {
            ...filterValue?.region,
            markets: allCountryCodes,
            type: 'market',
          },
        }
      : {
          ...filterValue,
          region: {
            ...filterValue?.region,
            markets: ['global'],
            type: 'market',
          },
        };

    // 同步更新筛选器 UI
    setFilterValue(newFilterValue);

    // 重新请求数据，将更新后的 filterValue 作为第二个参数传入，
    // 避免请求完成后 getIndexPageData 内部用旧的 filterValue 覆盖 region
    const newParams = {
      ...fetchParams,
      b_group_by_market: isByCountry,
      regions: isByCountry ? allCountryCodes : ['global'],
      region_type: 'market',
    };
    getIndexPageData(newParams, newFilterValue);

    // 当前在饼图模式下切换按国家，需要重新请求饼图数据（带 b_group_by_market）
    if (trendChartType === ChartType.Pie) {
      getKPITrendsPiePlatformData({
        params: newParams,
        isPie: true,
        isByPlatform: byDevice,
        isByCountry,
      });
    }
  };

  const getDownloadFetchParams = () => {
    const trendMetricSelection =
      filterValue?.metric_selection_for_trends?.value || {};
    const metricsOrder =
      trendMetricSelection?.metrics ||
      trendMetricSelection?.metricsOptionsByConfigOrder?.map(
        (item: { value: string }) => item.value,
      ) ||
      [];
    const sourceMetricsResolved =
      trendMetricSelection?.source_metrics ||
      fetchParams.source_metrics ||
      {};
    const alineaTrueDataMappings = getAlineaTrueDataSelections(
      selectMetricsOptionsCur,
    ).map((selection) => {
      const metricOption = selectMetricsOptionsCur.find(
        (item: any) => item?.value === selection.pageMetric,
      );
      // 下载列头固定使用英文资源，避免跟随当前页面 locale 输出中文。
      const metricName =
        (typeof metricOption?.text === 'string' &&
          (METRIC_LOCALES_EN as Record<string, string>)[metricOption.text]) ||
        selection.pageMetric;
      const sourceName =
        allMetricsSourcesOption.find((item: any) => item?.value === 'alinea')
          ?.text || '';
      const metricLegendName =
        metricName && sourceName && !metricName.startsWith(sourceName)
          ? `${sourceName} ${metricName}`
          : metricName;
      const trueDataSuffix = TOPCHARTS_LOCALES_EN.dbi_alinea_true_data_suffix;
      return {
        ...selection,
        legendName: formatTrueDataSeriesName(
          metricLegendName,
          trueDataSuffix,
        ),
      };
    });
    const paramsTmp: {
      [key: string]: any;
    } = {
      ...fetchParams,
      segment: 'All',
      subSegment: 'allMetrics',
      unified_id: gameId,
      unified_ids: [gameId],
      currentMetric: 'allMetrics',
      isCountriesPage: false,
      regionOptions,
      hasDatabrainData: hasDatabrainCalibratedData,
      source_metrics: sourceMetricsResolved,
      metrics: metricsOrder,
      order_metrics: buildOrderMetricsFromPageMetricValues(
        metricsOrder,
        sourceMetricsResolved,
      ),
      alinea_true_data_mappings: alineaTrueDataMappings,
    };
    if (downloadParamsPatch) {
      Object.assign(paramsTmp, downloadParamsPatch);
    }
    return paramsTmp;
  };

  const exportTableCom = (
    <ExportTable
      buttonType="icon"
      tabType={tabType}
      entityType={entityType}
      buttonClassName={'trends-table-download-icon'}
      tableParams={getDownloadFetchParams()}
      businessType={download.businessType}
      isDisableDownload={loading}
      isShowMaxDownloadRowsTips={false}
      downloadModalSize={download.downloadModalSize}
      isDisableDataAmount={true}
      isUseFormDownload={isHourlyMode}
      newStyleFileName={`${basicInfo?.name}${'_Stats'}`}
      pageId={TopchartPageId.PCConsoleMetricsTable}
      useWebDownload={true}
      downloadKey={'pcConsoleDetail'}
      downloadLogConfigKey={'TopChartsPCAndConsoleGamesKPITrendsDownloadButton'}
    />
  );

  const { currentMetricSumAvg, showSum, showAvg, showMax } = useShowSumAvgInfo({
    metric: visualMetricValue,
    sumAvgMaxList,
  });



  useEffect(() => {
    if (isFirst.current && !loading) {
      // if (decodeUrlToFilterValue.visualMetricValue) {
      //   setDefaultVisualMetricsValue(decodeUrlToFilterValue.visualMetricValue);
      //   handleMetricSelectChange(decodeUrlToFilterValue.visualMetricValue, false);
      // }
      if (decodeUrlToFilterValue.byDevice) {
        handleByPlatformChange(decodeUrlToFilterValue.byDevice, false);
      }
    }
  }, [isFirst.current, loading]);

  // Sync KPI hook's visual metric value with our managed state
  useEffect(() => {
    // 有暂存指标跳转指定要勾选的指标时，勾选暂存指定要勾选的指标
    if (jumpVisualMetrics.current !== null) {
      const defaultVisualMetrics = [...jumpVisualMetrics.current];
      // 设置可视化指标
      setKpiVisualMetricValue(defaultVisualMetrics[0]);
      setVisualMetricValue(defaultVisualMetrics[0]);
      if (JSON.stringify(visualMetricValues) !== JSON.stringify(defaultVisualMetrics)) {
        setVisualMetricValues(defaultVisualMetrics);
      }
      return;
    }

    if (!selectVisMetricsOptionsEffective?.length) return;

    const isMetricInOptions = (metric?: string) =>
      Boolean(
        metric &&
          selectVisMetricsOptionsEffective.some(
            (option: { value: string }) => option.value === metric,
          ),
      );

    const fallbackMetric =
      (isMetricInOptions(kpiVisualMetricValue)
        ? kpiVisualMetricValue
        : undefined) ||
      findFirstNonHourlyCcuMetric(selectVisMetricsOptionsEffective) ||
      selectVisMetricsOptionsEffective[0]?.value;

    if (!fallbackMetric) return;

    // 图表按 visualMetricValue 过滤数据；selector 用 visualMetricValues，两者可能不同步
    if (!isMetricInOptions(visualMetricValue)) {
      setVisualMetricValue(fallbackMetric);
      setVisualMetricValues([fallbackMetric]);
      if (kpiVisualMetricValue !== fallbackMetric) {
        setKpiVisualMetricValue(fallbackMetric);
      }
      return;
    }

    const validCurrentValues = (visualMetricValues || []).filter((value) =>
      isMetricInOptions(value),
    );

    if (!validCurrentValues.length) {
      if (visualMetricValue !== fallbackMetric) {
        setVisualMetricValue(fallbackMetric);
      }
      setVisualMetricValues([fallbackMetric]);
      return;
    }

    if (validCurrentValues.length !== visualMetricValues.length) {
      setVisualMetricValues(validCurrentValues.slice(0, 2));
    }
  }, [
    kpiVisualMetricValue,
    selectVisMetricsOptionsEffective,
    visualMetricValue,
    visualMetricValues,
    setVisualMetricValue,
    setKpiVisualMetricValue,
  ]);

  /** Hour 模式：CommonFilter 应用 timeFilterValues 会覆盖 filterValue，须与 sync 后的 rangeTime 一致 */
  const apiTimeFilterValues = useMemo(() => {
    const isHourlyEffective =
      isHourlyMode || isKpiTrendsHourlyGranularity(fetchParams.date_type);
    if (isHourlyEffective) {
      const hourRange = filterValueForRender?.rangeTime;
      return {
        type: isKpiTrendsHourlyGranularity(fetchParams.date_type)
          ? fetchParams.date_type
          : 'hourly',
        value:
          hourRange?.type === 'hour' && Array.isArray(hourRange.value)
            ? hourRange.value
            : ['', ''],
      };
    }
    return {
      type: fetchParams.date_type,
      value: [fetchParams.start_date, fetchParams.end_date],
    };
  }, [
    isHourlyMode,
    fetchParams.date_type,
    fetchParams.start_date,
    fetchParams.end_date,
    filterValueForRender?.rangeTime,
  ]);



  return (
    <div className="dbi-mobile-games-stats dbi-mobile-games-stats-kpi">
      <div className={`dbi-KPITrends-compage ${pageClassName}`}>
        {/* 筛选器 */}
        <CommonFilter
          timeFilterValues={apiTimeFilterValues}
          cascaderFilterValue={{
            value: fetchParams?.segmentsByDownload || {},
          }}
          filterConfirm={(...params: any) => {
            // setCurrentSortMetric('date');
            updateSwitcherDisabled(params?.[0]);
            updateFilterDatas(
              ...params,
              userManuallyChangedRegionRef.current,
              {},
              userSegmentChangedRegionRef.current,
              userSegmentCloseRef.current,
              restoreDefault.current,
              specialCascader.current,
            );
            // URL 统一在 fetchFilterChange 接口返回后写入（syncedFilterValue），
            // 不在 confirm 时同步写：Hour 模式 confirmValue 仅含时间字段，
            // 离开 Hour 时 metrics/region/segment 尚未 restore，会写成空值。
          }}
          onChangeExtra={handleChangeExtra}
          filterValue={filterValueForRender}
          setFilterValue={setFilterValue}
          filterCfg={filterCfg}
          defaultInputList={activeDefaultInputList}
          isBasicLoading={false}
          sinceReleaseTime={getSinceReleaseTimeOfRangePicker(releaseTime)}
          earliestDataTime={earliestPeriod}
          rangeTimeComponentDefault={{ hour: ['', ''] }}
          regionOptions={regionOptions}
          getRadioOptionsTips={getRadioOptionsTips}
          // Add game context for logging
          gameId={gameId}
          gameName={basicInfo?.name}
          onFilterLog={logKpiTrendsFilterChange}
        />
        <TrendsVisualTableContent
          className="dbi-trend-allmetrics"
          cardTitle={
            <>
              {formatMessage({ id: `dbi_detail_trend` })}{' '}
              <TipContext
                className="card-slot-v2-right-tip"
                Performance="left"
                tipText={`${formatMessage({
                  id: `dbi_detail_earliest_date`,
                })}: ${formattedEarliestDay}`}
              />
              {!loading && hourSegmentUi.showSumAvgInTitle && (
                <div className="dbi-trends-sum-avg-container">
                  {showSum && (
                    <div>
                      {showMax ? 'Max:' : 'Sum:'} {currentMetricSumAvg.sum}
                    </div>
                  )}
                  {showAvg && <div>Avg: {currentMetricSumAvg.avg}</div>}
                </div>
              )}
            </>
          }
          entityType={entityType}
          gameName={basicInfo?.name}
          gameCover={basicInfo?.cover}
          regionsCountries={regionOptions || []}
          dateType={fetchParams?.date_type}
          startDate={fetchParams?.start_date}
          endDate={fetchParams?.end_date}
          gameId={gameId}
          tableData={trendsTableDataList}
          sumAvgMaxList={sumAvgMaxList}
          lineData={trendsTableDataList}
          pieData={pieData}
          stackLineData={byCountry ? countryTrendsData : deviceTrendsDatas}
          stackPieData={devicePieDatas}
          chartType={trendChartType}
          setChartType={setTrendChartType}
          cardStatus={cardStatus}
          pageCfg={{
            ...(KPITrendsPageConfig || {}),
            tableMetricList: tableMetricListExpanded,
          }}
          earliestDay={formattedEarliestDay}
          baseReleaseTime={baseReleaseTimeData}
          earliestPeriod={earliestPeriod}
          pageSortAttr={pageSortAttr}
          chartLoading={loading}
          setChartLoading={setFetchLoading}
          visualisTitleNow={visualisTitleNow}
          exportTableCom={exportTableCom}
          visualMetricValue={visualMetricValue}
          visualMetricValues={visualMetricValues}
          setVisualMetricValue={setVisualMetricValue}
          isStepLine={isMultiValuePriceMetric(visualMetricValue)}
          isManuallyTriggerMetricSelectRef={isManuallyTriggerMetricSelectRef}
          onChartTypeChange={handleChartTypeChange}
          byDevice={byDevice}
          handleByPlatformChange={handleByPlatformChange}
          byCountry={byCountry}
          handleByCountryChange={handleByCountryChange}
          hasVisualMetricValue={Boolean(selectVisMetricsOptionsEffective?.length)}
          hasDatabrainData={hasDatabrainCalibratedData}
          hasAlineaData={hasAlineaCalibratedData}
          alineaTrueDataSeries={alineaTrueDataSeries}
          rightDom={
            hourSegmentUi.showVisualMetricSelector &&
            Boolean(selectVisMetricsOptionsEffective?.length) && (
              <VisualMetricSelectorDual
                disabled={!selectVisMetricsOptionsEffective?.length}
                options={selectVisMetricsOptionsEffective}
                values={visualMetricValuesForSelector}
                onChange={handleDualMetricChangeWrapper}
              />
            )
          }
          chartNodataMsg={`<div class="dbi-nodata-message"  style="margin-top:-60px"> ${formatMessage(
            { id: 'dbi_info_allMetrics_nodata_msg_new' },
          )}</div>`}
          onMetricExplanationClick={(key, payload) => {
            // 不再通过动态映射修改地区，只处理「查看标定数据」逻辑
            handleMetricExplanationTipsClick(key, payload, {
              filterValue,
              gameId: gameId,
              onClickViewCalibrationData: handleViewCalibrationData,
            });
          }}
          feedBackParams={feedBackParams}
          enableOpinionEventAnnotation={showOpinionEventSetting}
          controlledEventAnnotation={
            showOpinionEventSetting
              ? {
                  eventData: opinionEventData,
                  chartEventSetting: opinionChartEventSetting,
                  changeEventSetting: changeOpinionEventSetting,
                  eventLoading: opinionEventLoading,
                  settingStorageKey,
                }
              : undefined
          }
          opinionEventConfig={
            showOpinionEventSetting
              ? {
                  gameIds: eventClusterGameIds,
                  settingStorageKey,
                  startTime: fetchParams?.start_date || '',
                  endTime: fetchParams?.end_date || '',
                  dateType: fetchParams?.date_type,
                  entityType,
                }
              : undefined
          }
        />
      </div>
      {/* 数据源解释说明组件 */}
      {hourSegmentUi.showDataSourceExplanation && (
        <DataSourceExplanation
          domain="dbi_pcconsole_sourcelist_state"
          triggerBtnText={formatMessage({ id: 'dbi_pcconsole_source_explanation' })}
          dataSourceList={DATASOURCE_EXPLANATION_HTML_DATASOURCE_LIST}
          htmlContentMap={getDataSourceExplanationHtmlContent(locale)}
          trigger={dataSourceExplanationTriggerRef}
          body={dataSourceExplanationBodyRef}
        />
      )}
    </div>
  );
};

export default KPITrends;
